import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavbarProps {
  onOpenWaitlist: () => void;
}
export const Navbar: React.FC<NavbarProps> = ({
  onOpenWaitlist
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="flex justify-between items-center" data-id="element-198">
          <div className="flex items-center" data-id="element-199">
            <a href="#" className="flex items-center" data-id="element-200">
              <span className="text-3xl md:text-4xl font-literata font-medium" data-id="element-201">
                Re:<span className="text-rejoy-coral" data-id="element-202">Joy</span>
              </span>
            </a>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-203">
            <a href="#how-it-works" className="text-ink-text hover:text-rejoy-coral transition-colors duration-300 py-2" data-id="element-204">
              How It Works
            </a>
            <a href="#therapists" className="text-ink-text hover:text-rejoy-coral transition-colors duration-300 py-2" data-id="element-205">
              Therapists
            </a>
            <a href="#" className="text-ink-text hover:text-rejoy-coral transition-colors duration-300 py-2 flex items-center gap-2" data-id="element-206">
              Team
              <span className="text-xs bg-sandstone text-plum-gray px-2 py-0.5 rounded" data-id="element-207">
                Coming Soon
              </span>
            </a>
            <a href="#" className="text-ink-text hover:text-rejoy-coral transition-colors duration-300 py-2 flex items-center gap-2" data-id="element-208">
              About
              <span className="text-xs bg-sandstone text-plum-gray px-2 py-0.5 rounded" data-id="element-209">
                Coming Soon
              </span>
            </a>
          </nav>
          <div className="hidden md:block" data-id="element-210">
            <button onClick={onOpenWaitlist} className="btn-primary" data-id="element-211">
              Join Waitlist →
            </button>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-212">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-ink-text p-2" data-id="element-213">
              {isMenuOpen ? <XIcon size={24} data-id="element-214" /> : <MenuIcon size={24} data-id="element-215" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white" data-id="element-216">
          <div className="px-4 pt-2 pb-4 space-y-4" data-id="element-217">
            <a href="#how-it-works" className="block text-ink-text hover:text-rejoy-coral py-2" data-id="element-218">
              How It Works
            </a>
            <a href="#therapists" className="block text-ink-text hover:text-rejoy-coral py-2" data-id="element-219">
              Therapists
            </a>
            <a href="#" className="block text-ink-text hover:text-rejoy-coral py-2 flex items-center gap-2" data-id="element-220">
              Team
              <span className="text-xs bg-sandstone text-plum-gray px-2 py-0.5 rounded" data-id="element-221">
                Coming Soon
              </span>
            </a>
            <a href="#" className="block text-ink-text hover:text-rejoy-coral py-2 flex items-center gap-2" data-id="element-222">
              About
              <span className="text-xs bg-sandstone text-plum-gray px-2 py-0.5 rounded" data-id="element-223">
                Coming Soon
              </span>
            </a>
            <button onClick={onOpenWaitlist} className="btn-primary w-full" data-id="element-224">
              Join Waitlist →
            </button>
          </div>
        </div>}
    </header>;
};